import { isDefined } from "@clipboard-health/util-ts";
import { APP_V2_APP_EVENTS, logEvent } from "@src/appV2/lib/analytics";
import { getFirebaseSingleton } from "@src/lib/firebase/src/lib/firebaseSingleton";
// eslint-disable-next-line no-restricted-imports -- legacy, use @clipboard-health/date-time. See https://www.notion.so/BP-Date-Time-2ef8643321f48032ad80e8a5b30aa278 for more information
import moment from "moment-timezone";
import { Dispatch } from "redux";

import { ActionType, getUserByEmail } from "../store/session";

export async function populateSessionAfterLogin(
  dispatch: Dispatch,
  options?: { isSignup?: boolean }
) {
  const userAgent = await getUserByEmail();
  const user = getFirebaseSingleton().currentUser;

  if (!isDefined(userAgent) || !isDefined(userAgent._id)) {
    if (options?.isSignup) {
      dispatch({
        type: ActionType.LOGGED_IN,
        data: {
          profile: {
            phone: user?.phoneNumber,
          },
        },
      });
      return;
    }
    throw new Error("getUserByEmail returned an invalid response: missing user or user ID");
  }

  const { agent, tmz, sendBirdAccessToken, _id } = userAgent;

  if (tmz) {
    moment.tz.setDefault(tmz);
  }

  dispatch({
    type: ActionType.LOGGED_IN,
    data: {
      userId: _id,
      sendBirdAccessToken,
      profile: {
        name: agent?.name,
        email: agent?.email,
        phone: agent?.phone ?? user?.phoneNumber,
      },
    },
  });

  logEvent(APP_V2_APP_EVENTS.AUTHORIZED_WORKER, {
    userId: _id,
    email: agent?.email,
    phone: agent?.phone ?? user?.phoneNumber,
    name: agent?.name,
  });
}
